import { render, staticRenderFns } from "./TagInternal.vue?vue&type=template&id=358ca5f2&scoped=true&lang=pug"
import script from "./TagInternal.vue?vue&type=script&lang=js"
export * from "./TagInternal.vue?vue&type=script&lang=js"
import style0 from "./TagInternal.vue?vue&type=style&index=0&id=358ca5f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358ca5f2",
  null
  
)

export default component.exports